module.exports = __webpack_public_path__ + "static/media/27OCHA8.53a80825.jpg";